import type { OrderItem } from '../graphql/query/getOrder';

/**
 * Gets the tracking number for an item from a list of shipment groups.
 * This is used when we already have grouped shipment data.
 *
 * If the item ID is not found directly, it tries to find the item by SKU
 * to handle cases where virtual items have different IDs than the original items.
 */
export const getTrackingNumberFromGroups = (
  shipmentGroups: Array<{ trackingNumber: string; items: OrderItem[] }>,
  itemId: string,
  originalItem?: OrderItem,
): string | undefined => {
  // First try to find by exact item ID
  const group = shipmentGroups.find((group) =>
    group.items.some((item) => item.id === itemId),
  );

  if (group) {
    return group.trackingNumber;
  }

  // If not found and we have the original item, try to find by SKU
  if (originalItem?.sku) {
    const matchingGroup = shipmentGroups.find((group) =>
      group.items.some((item) => item.sku === originalItem.sku),
    );

    if (matchingGroup) {
      return matchingGroup.trackingNumber;
    }
  }

  return undefined;
};
